export default function PromoVideo() {
  return (
    <section className="relative h-64 sm:h-80 md:h-96 lg:h-[32rem] w-full overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/promo.jpg')`
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      {/* Content Container */}
      <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6 md:px-8">
        <div className="text-center max-w-md w-full">
          {/* Blue Road Text */}
          <p className="text-blue-400 text-xs sm:text-sm font-medium mb-2 tracking-wide">Blue Road</p>
          
          {/* Promo Video Title */}
          <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8">Promo Video</h2>
          
          {/* Play Button */}
          <button
            aria-label="Play Promo Video"
            className="group relative flex items-center justify-center w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 mx-auto transform hover:scale-105 transition-all duration-300"
          >
            {/* Outer Circle */}
            <div className="absolute inset-0 rounded-full border-2 border-blue-500 group-hover:border-blue-400 transition-colors group-hover:scale-110 duration-300"></div>
            
            {/* Inner Circle */}
            <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-blue-500 hover:bg-blue-400 rounded-full flex items-center justify-center transition-all duration-300 group-hover:shadow-lg group-hover:shadow-blue-500/30">
              {/* Play Icon */}
              <svg 
                className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-white ml-0.5" 
                fill="currentColor" 
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </button>
        </div>
      </div>
    </section>
  )
}